import React, { ButtonHTMLAttributes, MouseEvent } from "react";

type ButtonProps = {
  children: React.ReactNode;
  className?: string;
  isLoading?: boolean;
  variant?:
    | "dark-gray"
    | "primary"
    | "warning"
    | "white"
    | "default"
    | "light-blue"
    | "light-success"
    | "success"
    | "light-danger"
    | "light-warning"
    | "purple";
  isValid?: boolean;
} & ButtonHTMLAttributes<HTMLButtonElement>;

function Button({
  children,
  className,
  variant,
  isValid,
  onClick,
  isLoading,
  ...rest
}: ButtonProps) {
  const btnClass = `btn cursor-pointer! ${className || ""} ${
    variant ? `btn-${variant}` : ""
  } ${isValid !== undefined && !isValid ? "disabled-btn" : ""}`;

  const createRipple = (event: MouseEvent<HTMLButtonElement>) => {
    const button = event.currentTarget;
    const circle = document.createElement("span");
    const diameter = Math.max(button.clientWidth, button.clientHeight);
    const radius = diameter / 2;

    circle.style.width = circle.style.height = `${diameter}px`;
    circle.style.left = `${event.clientX - button.offsetLeft - radius}px`;
    circle.style.top = `${event.clientY - button.offsetTop - radius}px`;
    circle.classList.add("ripple");

    const ripple = button.getElementsByClassName("ripple")[0];

    if (ripple) {
      ripple.remove();
    }

    button.appendChild(circle);

    if (onClick) {
      onClick(event);
    }
  };

  return (
    <button
      className={btnClass}
      disabled={isValid === false}
      {...rest}
      onClick={createRipple}
    >
      {isLoading ? <span className="loader m-0"></span> : children}
    </button>
  );
}

export default Button;
